import { Component, OnInit } from '@angular/core';
import { AdminService, PlantType } from '../../services/admin.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { ObjectsComponent } from '../objects/objects.component';
import { ProblemGroupsComponent } from '../problem-groups/problem-groups.component';
import { TeamGroupsComponent } from '../team-groups/team-groups.component';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [NgFor, MatButton, NgIf, MatToolbar, MatTabNav, MatTabLink, NgClass, MatTabNavPanel, ObjectsComponent, ProblemGroupsComponent, TeamGroupsComponent]
})
export class AdminComponent implements OnInit {

  objectList$: Subscription;
  mDataSource: {};
  plantList: PlantType[];

  selectedSite:string="";
  activeLink:string="objects";

  constructor(
    private svcAdmin: AdminService) {}

  ngOnInit(): void {
    this.getSiteObjectList();
  }

  getSiteObjectList() {
    this.svcAdmin.plantList().subscribe((
      out => {
        this.plantList = out.Body;
      }
    ));
  }

  selectSite(site: string) {
    this.selectedSite = site;
  }
}